import { render } from "./ScoreLabel.vue?vue&type=template&id=4437c208&scoped=true"
import script from "./ScoreLabel.vue?vue&type=script&lang=js"
export * from "./ScoreLabel.vue?vue&type=script&lang=js"

import "./ScoreLabel.vue?vue&type=style&index=0&id=4437c208&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4437c208"]])

export default __exports__